import * as yup from "yup";
import dayjs from "dayjs";

export const getUserInfoSchema = () =>
  yup.object().shape({
    firstName: yup
      .string()
      .required("Please enter your First name")
      .max(30, "First name must not exceed 30 characters"),
    lastName: yup
      .string()
      .required("Please enter your Last name")
      .max(30, "Last name must not exceed 30 characters"),
    email: yup
      .string()
      .required("Please enter a valid Email address")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        "Invalid email format"
      ),
    city: yup.string().required("Please enter your Location"),
    otherCity: yup
      .string()
      .test("city", "Please enter Other city name", function (value) {
        const city = this.parent.city;
        return city === "Other" ? !!value : true;
      }),
    dob: yup
      .date()
      .required("Please enter a valid Date of birth")
      .test(
        "valid-date",
        "Age must be between 3 and 100 years",
        function (value) {
          if (value) {
            const saveDate = dayjs().startOf("day");
            const age = saveDate.diff(value, "years");
            return age >= 3;
          }
          return true;
        }
      )
      .test(
        "valid-date-above",
        "Age must be between 3 and 100 years",
        function (value) {
          if (value) {
            const saveDate = dayjs().startOf("day");
            const age = saveDate.diff(value, "years");
            return age <= 99;
          }
          return true;
        }
      )
      .typeError("Date of birth is invalid"),
    terms: yup
      .boolean()
      .oneOf([true], "Please accept 'Terms & Conditions' and 'Privacy Policy'")
      .required("Please accept 'Terms & Conditions' and 'Privacy Policy'"),
  });